// Call Super Admin Registrations
import { apiAuth } from '../../utils/hooks';

const getAllUsers = (params) => {
    return apiAuth()
        .get('/registration', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAllCharities = (params) => {
    return apiAuth()
        .get('/registration/association', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchRegistration = (idAssociation, token) => {
    return apiAuth()
        .patch(`/registration/association/${idAssociation}`, {
            account_token: token,
        })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getOneCharity = (idAssociation) => {
    return apiAuth()
        .get(`/registration/association/${idAssociation}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchAssociation = (idAssociation, validatedCharity) => {
    return apiAuth()
        .patch(`/association/${idAssociation}`, validatedCharity)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export {
    getAllUsers,
    getAllCharities,
    patchRegistration,
    getOneCharity,
    patchAssociation,
};
